import { UserProfile } from "../utils/authStorage";
import { apiFetch, FEED_API_BASE } from "./apiClient";

/**
 * Fetch the authenticated user's full profile. The backend auto-provisions
 * a profile on first access, so there is no separate "create profile" call.
 */
export const fetchMyProfile = (): Promise<UserProfile> =>
  apiFetch<UserProfile>("/v1/profile/me", { auth: true, base: FEED_API_BASE });
